import { render, staticRenderFns } from "./VPlannerColumn.vue?vue&type=template&id=46b6e85c&"
import script from "./VPlannerColumn.vue?vue&type=script&lang=js&"
export * from "./VPlannerColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports